import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 border-t border-background-200/70 bg-secondary-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-base"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-foreground-950">
                适合夫妻二人看的影片
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              我们为夫妻与情侣挑选适合一起观看的爱情、温情与喜剧电影，
              提供贴心分类、观影指南与真实推荐，帮你们把每个共处的夜晚变得值得纪念。
            </p>
            <p className="mt-4 text-xs text-foreground-600">
              本站所有影片信息与推荐内容均为演示示例，不提供任何播放或下载服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <Link to="/category" className="cursor-pointer hover:text-primary-700">
                影片分类
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <Link
                    to={`/category?category=${cat.key}`}
                    className="text-sm text-foreground-700 transition-colors hover:text-primary-700 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <Link to="/guide" className="cursor-pointer hover:text-primary-700">
                网站导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-700 transition-colors hover:text-primary-700 cursor-pointer"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/guide"
                  className="text-sm text-foreground-700 transition-colors hover:text-primary-700 cursor-pointer"
                >
                  观影指南
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-700 transition-colors hover:text-primary-700 cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-background-300/60 pt-6">
          <p className="text-xs text-foreground-600">
            版权所有 © {year} 适合夫妻二人看的影片 · 保留所有权利
          </p>
          <p className="text-xs text-foreground-600">
            内容仅作推荐参考，影片版权归各自权利人所有
          </p>
        </div>
      </div>
    </footer>
  );
}